import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  ButtonGroup,
  Label,
  ListGroup,
  OverlayTrigger,
  ToggleButton,
  Tooltip,
} from '@readcloud/component-library';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  ToggleGroup,
  Select,
  SelectItem,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from '@readcloud/ui';
import packageJson from 'package.json';
import React, { ReactNode } from 'react';
import { EpubTheme } from '../../../types/BottomToolbarConstants';
interface Props {
  onEnableWalkthrough: () => void;
  onFontChange: (font: string) => void;
  font: string;
  theme: string;
  fontSize: number;
  darkMode: boolean;
  onFontSizeChange: (fontSize: number) => void;
  onThemeChange: (theme: string) => void;
  onDarkModeChange: (val: boolean) => void;
}
const themeOptions: Array<{ value: EpubTheme; label: React.ReactNode }> = [
  {
    value: 'night',
    label: <span>Night</span>,
  },
  {
    value: 'day',
    label: <span>Day</span>,
  },
  {
    value: 'sepia',
    label: <span>Sepia</span>,
  },
];
const fontSizeOptions = [
  {
    value: '0.7',
    label: <span style={{ fontSize: '0.5rem' }}>Aa</span>,
  },
  {
    value: '1',
    label: <span style={{ fontSize: '0.8rem' }}>Aa</span>,
  },
  {
    value: '1.6',
    label: <span style={{ fontSize: '1.2rem' }}>Aa</span>,
  },
  {
    value: '2',
    label: <span style={{ fontSize: '1.6rem' }}>Aa</span>,
  },
  {
    value: '2.5',
    label: <span style={{ fontSize: '2rem' }}>Aa</span>,
  },
];

/* let fontToString = font =>
  switch (font) {
  | OpenDyslexic => "Open Dyslexic, sans-serif"
  | OpenSans => "OpenSans, sans-serif"
  | Quicksand => "Quicksand, sans-serif"
  | SansSerif => "sans-serif"
  | Montserrat => "Montserrat, sans-serif"
  }; */
const fontOptions = [
  {
    value: 'Open Dyslexic, sans-serif',
    label: 'OpenDyslexic',
  },
  {
    value: 'OpenSans, sans-serif',
    label: 'OpenSans',
  },
  {
    value: 'Quicksand, sans-serif',
    label: 'Quicksand',
  },
  {
    value: 'sans-serif',
    label: 'SansSerif',
  },
  {
    value: 'Montserrat, sans-serif',
    label: 'Montserrat',
  },
];
export const EPUBSettings: React.FC<Props> = (props) => {
  const handleFontChange = (selected: { label: string; value: string }) => {
    props.onFontChange(selected.value);
  };
  const handleFontSizeChange = (fontSize: string) => {
    props.onFontSizeChange(parseFloat(fontSize));
  };

  const getFontSelectItemProps = (index: number) => ({
    fontFamily: fontOptions[index].value,
  });

  const handleDarkModeChange = (val: string) => {
    if (val === 'true' || val === 'false') {
      props.onDarkModeChange(val === 'true' ? true : false);
    }
  };

  const Options = ({
    label,
    options,
    value,
    onChange,
    disabled,
  }: {
    disabled?: boolean;
    label: string;
    options: { value: string | number; label?: ReactNode }[];
    value: string | number;
    onChange: (v: string) => void;
  }) => (
    <>
      <Label className="rc-flex ">{label}</Label>
      <ToggleGroup
        type="single"
        ensureValue
        className="rc-flex rc-w-full"
        onValueChange={(val) => onChange(val)}
        value={value?.toString()}
      >
        {options.map((option) => (
          <ToggleButton
            id={`${label}-${option?.value?.toString()}`}
            type="button"
            name={`${label}-${option?.value?.toString()}`}
            value={option.value.toString()}
            key={`${label}-${option?.value?.toString()}`}
          >
            {option.label}
          </ToggleButton>
        ))}
      </ToggleGroup>
    </>
  );

  return (
    <div className="rc-flex rc-items-start rc-flex-col rc-p-2">
      {false && (
        <div className="rc-flex rc-w-full rc-justify-between rc-items-center">
          {/* {versions()} */}

          <OverlayTrigger
            overlay={<Tooltip id="tt-walkthrough">Enable walkthrough</Tooltip>}
            placement="top"
          >
            <Button
              size="sm"
              variant="light"
              rounded
              onClick={props.onEnableWalkthrough}
            >
              <FontAwesomeIcon icon={'info'} />
            </Button>
          </OverlayTrigger>
        </div>
      )}
      <span>Version: {packageJson.version}</span>
      <div className="rc-w-full">
        <hr />
      </div>

      {false && <div className="rc-py-2" />}
      {false && (
        <Options
          label="Dark Mode"
          value={props?.darkMode?.toString()}
          onChange={handleDarkModeChange}
          options={[
            { value: 'true', label: 'Enabled' },
            { value: 'false', label: 'Disabled' },
          ]}
        />
      )}
      <Label>Font</Label>
      <Select value={props.font} onValueChange={props.onFontChange}>
        <SelectTrigger className="rc-w-full">
          <SelectValue placeholder="Select a font" />
        </SelectTrigger>
        <SelectContent className="rc-z-[2100] rc-bg-background rc-max-h-[var(--radix-popper-available-height)] rc-rounded">
          {fontOptions.map((font) => (
            <SelectItem key={font.value} value={font.value}>
              {font.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <div className="rc-py-2" />
      <Options
        value={props?.fontSize?.toString()}
        options={fontSizeOptions}
        onChange={handleFontSizeChange}
        label="Font Size"
      />

      <div className="rc-py-2" />
      <Options
        value={props?.theme}
        options={themeOptions}
        onChange={props.onThemeChange}
        label="Theme"
      />
      {/* <HorizontalSelect
          value={this.props.theme}
          onChange={this.props.onThemeChange}
          items={themeOptions}
        /> */}
    </div>
  );
};
